import { Box, VStack, Text } from '@chakra-ui/react'

/**
 * [LEGAL] Shown when the only cached walk list / script on this device has passed its
 * 7-day TTL (spec §2.5 / §6a). Copy is verbatim from spec §6(a).
 */
export function CacheExpiredNotice() {
  return (
    <Box p={4}>
      <VStack gap={2} align="stretch" bg="bg.muted" borderRadius="md" p={4}>
        <Text fontWeight="semibold">This list has expired on this device.</Text>
        <Text color="fg.muted" fontSize="sm">
          Reconnect to the internet to refresh it. For security, offline lists are cleared after 7 days.
        </Text>
      </VStack>
    </Box>
  )
}
